const request = require('request');
const config = require('./config');

const getAll = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/opcoesRecebimento',
      method: 'GET',
      qs: filters
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

const getDescontos = (token,filters) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: config.URL_BACKEND+'/opcoesRecebimento/descontos',
      method: 'GET',
      qs: filters
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

const put = (token, body) => {
  return new Promise((resolve,reject) => {
    request({
      headers: {
        'Content-Type': 'application/json',
        'User-Token': token
      },
      uri: `${config.URL_BACKEND}/opcoesRecebimento`,
      method: 'PUT',
      body: JSON.stringify(body)
    }, (err, res, body) => {
      if (err) return reject(err);
      resolve({err: err, res: res, body: body});
    });
  });
};

module.exports = {
  getAll:getAll,
  getDescontos:getDescontos,
  put:put
}